import React, { useContext, useEffect, useRef, useState } from 'react';
import './Header.scss'
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { OverlayPanel } from 'primereact/overlaypanel';
import { useNavigate } from 'react-router-dom';
import { SocketContext } from '../SocketContext/SocketContext';
import { Post } from '../../Config/config';
import SnackBarNotification from '../SnackBarNotification/SnackBarNotification';
import Loader from '../Loader/Loader';
import Reminder from '../Reminder/Reminder';
import { decryptLocalData, encryptData, getFcodeByPath, key } from '../GlobalFunction/GlobalFunction';
import { FloatLabel } from 'primereact/floatlabel';
import { InputTextarea } from 'primereact/inputtextarea';
import Notification from '../Notification/Notification';

function Header(props) {
    const userData = JSON.parse(localStorage.getItem("userData"));

    const socket = useContext(SocketContext);
    // SankBar
    const [sankbar, setSankbar] = useState(false);
    const [sankbarText, setSankbarText] = useState("");
    const [sankbarColor, setSankbarColor] = useState("");
    // Loader
    const [loader, setLoader] = useState(false);
    const op = useRef(null);
    const op2 = useRef(null);
    const navigator = useNavigate();

    const [fullaName, setFullName] = useState();
    const [emailId, setEmailId] = useState();
    const [shortName, setShortName] = useState();
    const [Id, setId] = useState();
    const [userId, setuserId] = useState();
    const [remark, setRemark] = useState('');

    const addSale = userData?.Permissions?.find((item) => item.F_Code === "BTNSL")
    const addPurchase = userData?.Permissions?.find((item) => item.F_Code === "BTNPR")
    const addMore = userData?.Permissions?.find((item) => item.F_Code === "BTNMO")
    const porfileper = userData?.Permissions?.find((item) => item.F_Code === "PFL")

    const logout = () => {
        // socket.emit('logout', { UserId: userId?.UserId, CompanyCode: userId?.CompanyCode, Token: Id, EUser: userId?.EUser });
        setLoader(true)
        Post('User/LogOut', {
            UserId: userId?.UserId,
        }).then((res) => {
            setLoader(false)
            if (res) {
                if (res.status === 1) {
                    sessionStorage.clear();
                    localStorage.clear();
                    navigator('/login')
                }
            }
        })
    };

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem("userData"));
        const Id = decryptLocalData("ID");

        if (userData !== null && userData !== undefined) {
            setId(Id);
            setuserId(userData);
            setFullName(userData.Username);
            setEmailId(userData.UserEmail);
            setShortName(userData.Username?.substring(0, 1));
        } else {
            console.error('User data or ID is missing in localStorage');
        }

        socket.on('logoutSuccess', (data) => {
            if (data.status === 1) {
                navigator('/login');
            }
        });

        socket.on('logoutError', (data) => {
            console.error('Error logging out:', data.message);
        });

        return () => {
            socket.off('logoutSuccess');
            socket.off('logoutError');
        };
    }, [socket]);


    // useEffect(() => {
    //     const userData = JSON.parse(localStorage.getItem("userData"));
    //     if (userData !== null || undefined) {
    //         setFullName(userData.Username);
    //         setEmailId(userData.UserEmail);

    //         setShortName(userData.Username?.substring(0, 1));
    //     }
    // }, []);

    // profile

    const [isOpen, setIsOpen] = useState(false);
    const handleToggle = () => {
        setIsOpen(!isOpen);
    };

    const modalRef2 = useRef(null);

    useEffect(() => {
        const handleOutsideClick = (e) => {
            if (modalRef2.current && !modalRef2.current.contains(e.target)) {
                setIsOpen(false);
            }
        };

        const handleScroll = () => {
            setIsOpen(false);
        };

        if (isOpen) {
            document.addEventListener('mousedown', handleOutsideClick);
            window.addEventListener('scroll', handleScroll);
        }

        return () => {
            document.removeEventListener('mousedown', handleOutsideClick);
            window.removeEventListener('scroll', handleScroll);
        };
    }, [isOpen]);

    const handleFullScreen = () => {
        if (!document.fullscreenElement) {
            document.documentElement.requestFullscreen().catch(err => {
                console.error(`Error attempting to enable full-screen mode: ${err.message}`);
            });
        } else {
            if (document.exitFullscreen) {
                document.exitFullscreen();
            }
        }
    };

    const handleChange = (value, name) => {
        if (name === 'remark') {
            setRemark(value);
        }
    }

    const [showDialog, setShowDialog] = useState(false);

    const handleOpenAnyDesk = () => {
        setShowDialog(true);
    };

    const handleConfirm = () => {
        const timeout = setTimeout(() => {
            alert("It seems AnyDesk is not opening. Redirecting to the download page...");
            window.open("https://anydesk.com/download", "_blank");
        }, 2000);

        try {
            window.location.href = "anydesk:";
            window.addEventListener("blur", () => clearTimeout(timeout));
            setShowDialog(false);
        } catch (err) {
            console.error("Error while opening AnyDesk:", err);
            setShowDialog(false);
        }
    };

    const handleDialogConfirm = () => {
        handleConfirm();
        requestCall();
    };

    const handleCancel = () => {
        setShowDialog(false);
    };


    const requestCall = () => {
        const payload = {
            Number: userData ? userData?.UserMobile : "",
            Message: remark ? remark : ""
        };

        const { encryptedData, iv } = encryptData(payload, key);
        Post('Dashboard/CallSupport', {
            encryptedData, iv
        }).then((res) => {
            if (res) {
                if (res.status === 1) {
                        setSankbar(true);
                        setSankbarText(res?.message);
                        setSankbarColor("success");
                    setRemark('')
                } else {
                    setSankbar(true);
                    setSankbarText(res.message);
                    setSankbarColor("error");
                }
            }
        })
    };


    return (
        <div id='Header' className={`${props.siderOpen ? "headerOpen" : "headerColse"}`}>
            <div className='main'>
                <div className='siderbarIcon' onClick={() => props.setSidebarOpen(!props.siderOpen ? true : false)}>
                    <i className='pi pi-align-left'></i>
                </div>
                <div className='leftHeader'>
                    {/* <div className="p-inputgroup flex-1">
                        <span className="p-inputgroup-addon">
                            <i className="pi pi-search"></i>
                        </span>
                        <InputText placeholder="Search transactions" />
                    </div> */}
                </div>
                <div className='rightHeader'>
                    <div className='button'>

                        {addSale?.is_View === true &&
                            <Button label="Add Sale" className='add_sale' onClick={() => { navigator(`/addSaleInvoices/${getFcodeByPath("addSaleInvoices")}`); }} icon="pi pi-plus-circle" severity="danger" raised />
                        }

                        {addPurchase?.is_View === true &&
                            <Button label="Add Purchase" className='add_purchase' onClick={() => { navigator(`/addPurchaseBills/${getFcodeByPath("addPurchaseBills")}`); }} icon="pi pi-plus-circle" severity='info' raised />
                        }

                        {addMore?.is_View === true &&
                            <Button label="Add More" icon="pi pi-plus-circle" onClick={(e) => op2.current.toggle(e)} className='btn-color add_more' raised />
                        }

                        <OverlayPanel ref={op2}>
                            <div className='addmore'>
                                <div className='addmore-box'>
                                    <div className='sale'>
                                        <h4>SALES</h4>
                                        <div className='sale-box'>
                                            <div className='sale-line' onClick={() => { navigator(`/addSaleInvoices/${getFcodeByPath("addSaleInvoices")}`); }}>
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Sale Invoice</p>
                                                </div>
                                                <p className='key'>ALT + S</p>
                                            </div>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Sale Order</p>
                                                </div>
                                                <p className='key'>ALT + F</p>
                                            </div>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Sale Return</p>
                                                </div>
                                                <p className='key'>ALT + R</p>
                                            </div>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Payment In</p>
                                                </div>
                                                <p className='key'>ALT + I</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sale'>
                                        <h4>PURCHASE</h4>
                                        <div className='sale-box'>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Purchase Bill</p>
                                                </div>
                                                <p className='key'>ALT + P</p>
                                            </div>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Purchase Return</p>
                                                </div>
                                                <p className='key'>ALT + L</p>
                                            </div>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Payment Out</p>
                                                </div>
                                                <p className='key'>ALT + O</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='sale'>
                                        <h4>OTHERS</h4>
                                        <div className='sale-box'>
                                            <div className='sale-line' >
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Add Item</p>
                                                </div>
                                                <p className='key'>ALT + A</p>
                                            </div>
                                            <div className='sale-line'>
                                                <div className='sale-icon'>
                                                    <i className="pi pi-sort-up-fill" style={{ transform: 'rotateZ(90deg)' }} ></i>
                                                    <p>Expenses</p>
                                                </div>
                                                <p className='key'>ALT + E</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='footer'>
                                    <div className='short-cut'>
                                        All shortcut keys in box
                                    </div>
                                </div>
                            </div>
                        </OverlayPanel>
                    </div>

                    {/* <div className='pi pi-sun'></div> */}

                    <div className='Support_icons'>
                        <Button type='button' icon='pi pi-headphones' onClick={handleOpenAnyDesk} severity='help' raised />

                        <Dialog
                            visible={showDialog}
                            header="Request Call"
                            id='Support_icons'
                            footer={
                                <div>
                                    <Button label="Cancel" onClick={handleCancel} className="p-button-text" severity='secondary' />
                                    <Button label="Confirm" onClick={handleDialogConfirm} autoFocus severity='info' raised />
                                </div>
                            }
                            onHide={handleCancel}
                        >
                            <p>Please call <b>(+91) 9054 053 802</b> from your registered number.<br /> If you are requesting a call, click Confirm.</p>
                            <FloatLabel>
                                <InputTextarea
                                    value={remark}
                                    onChange={(e) => handleChange(e.target.value, 'remark')}
                                    rows={3} cols={36}
                                    id='remark'
                                    autoComplete='off'
                                />
                                <label htmlFor="remark">Remark</label>
                            </FloatLabel>
                        </Dialog>
                    </div>

                    <div className='fullscrin_icons'>
                        <Button type='button' icon='pi pi-expand' onClick={handleFullScreen} />
                    </div>

                    <Reminder />

                    <div className="icons">
                        {/* <Notification /> */}

                        {porfileper?.is_View === true &&
                            <div className='letter_word_click'>
                                <div className={`letter_word ${isOpen ? 'open' : ''}`} onClick={() => handleToggle()}>
                                    <h2>{shortName}</h2>
                                </div>

                                {isOpen && (
                                    <React.Fragment>
                                        <div className='toggleBar' ref={modalRef2}>
                                            <div className='nameBar'>
                                                <div className='letter_word2'>
                                                    <h2>{shortName}</h2>
                                                </div>
                                                <div className="username">
                                                    <h6>{fullaName}</h6>
                                                    <p>{emailId}</p>
                                                </div>
                                            </div>
                                            <nav className='navigation'>
                                                <ul>
                                                    <li onClick={() => { navigator(`/profile/${getFcodeByPath("profile")}`); setIsOpen(false) }}>Profile</li>
                                                    <li onClick={() => { navigator(`/general/${getFcodeByPath("general")}`); setIsOpen(false) }}> Setting </li>
                                                    <li className='hozaderline'></li>
                                                    <li onClick={() => logout()}> Log Out </li>
                                                </ul>
                                            </nav>
                                        </div>
                                        <div className='Backlayer' onClick={() => setIsOpen(false)}></div>
                                    </React.Fragment>
                                )}
                            </div>
                        }
                    </div>

                </div>
            </div>
            <SnackBarNotification
                open={sankbar}
                text={sankbarText}
                color={sankbarColor}
                sankbar={(value) => setSankbar(value)}
            />
            {loader ? <Loader /> : ""}

        </div>
    );
};

export default Header;